import React from 'react';
import { BookingContainer } from './components/BookingContainer';
import {
    ANIMATION_DELAY,
    POLLING_DELAY,
} from './pages/AppointmentDetails/constants';
import { paths } from './paths';
import { lazyImport, LazyComponent } from './components/LazyImportComponent';
import StartSignIn from './pages/StartSignIn';
import PatientInfo from './pages/PatientInfo';
import ReviewAndBook from './pages/ReviewAndBook';
import SignUp from './pages/SignUp';

export const Pages = {
    BookingComplete: 'BookingComplete',
    StartSignIn: 'StartSignIn',
    PatientInfo: 'PatientInfo',
    ReviewAndBook: 'ReviewAndBook',
    SignUp: 'SignUp',
};

const mappedPages = {};
[
    {
        component: lazyImport(
            () =>
                import(
                    /* webpackChunkName: "complete", webpackPrefetch: 50 */ './pages/BookingComplete'
                ),
            Pages.BookingComplete
        )(),
        page: Pages.BookingComplete,
    },
    {
        component: StartSignIn,
        page: Pages.StartSignIn,
    },
    {
        component: ReviewAndBook,
        page: Pages.ReviewAndBook,
    },
    {
        component: PatientInfo,
        page: Pages.PatientInfo,
    },
    {
        component: SignUp,
        page: Pages.SignUp,
    },
].forEach(p => {
    const Component = p.component;
    mappedPages[p.page] = props => (
        <LazyComponent
            componentName={p.page}
            onFailure={error => {
                console.log('route error! ', error);
                throw error;
            }}
        >
            <Component {...props} />
        </LazyComponent>
    );
});

export const childRoutes = [
    {
        path: paths.startSignInPath.concat('(/:bookingId)'),
        component: mappedPages.StartSignIn,
    },
    {
        path: paths.reviewAndBookPath.concat('(/:bookingId)'),
        component: mappedPages.ReviewAndBook,
        props: {
            animationDelay: ANIMATION_DELAY,
            pollingDelay: POLLING_DELAY,
        },
    },
    {
        path: paths.patientInfoPath.concat('(/:bookingId)'),
        component: mappedPages.PatientInfo,
    },
    {
        path: paths.signUpPath.concat('(/:bookingId)'),
        component: mappedPages.SignUp,
    },
    {
        path: paths.bookingCompletePath.concat('(/:bookingId)'),
        component: mappedPages.BookingComplete,
    },
];

export default {
    path: paths.basePath,
    component: BookingContainer,
    childRoutes,
};
